/**
 * Página de Gestión de Eventos
 * Muestra diferentes vistas según el rol del usuario
 */

import { Loader2 } from "lucide-react";
import { usePermissions } from "@/hooks/usePermissions";
import { useAuthStore } from "@/stores/authStore";
import ClubEventsView from "./components/ClubEventsView";
import AssociationEventsView from "./components/AssociationEventsView";
import MemberEventsView from "./components/MemberEventsView";

export default function EventsPage() {
  const { role } = usePermissions();
  const loading = useAuthStore((s) => s.loading);

  if (loading || !role) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 className="w-8 h-8 animate-spin text-primary-600" />
      </div>
    );
  }

  // Vista para Miembros (solo lectura)
  if (role === "member") {
    return <MemberEventsView />;
  }

  // Vista para Director de Club
  if (role === "club_director") {
    return <ClubEventsView />;
  }

  // Vista para Admin de Asociación
  if (role === "admin_association") {
    return <AssociationEventsView />;
  }

  // Vista por defecto (admin_union u otros)
  return <AssociationEventsView />;
}
